import { useEffect } from 'react'

const useDynamicSEO = ({
  title,
  description,
  keywords = [],
  ogTitle,
  ogDescription
}) => {
  useEffect(() => {
    document.title = title
    setMetaTag('name', 'description', description)
    setMetaTag('name', 'keywords', Array.isArray(keywords) ? keywords.join(', ') : keywords)
    setMetaTag('property', 'og:title', ogTitle || title)
    setMetaTag('property', 'og:description', ogDescription || description)

    return () => {}
  }, [
    title,
    description,
    keywords,
    ogTitle,
    ogDescription
  ])

  function setMetaTag(attr, key, content) {
    if (content) {
      let element = document.querySelector(`meta[${attr}="${key}"]`)
      if (!element) {
        element = document.createElement('meta')
        element.setAttribute(attr, key)
        document.head.appendChild(element)
      }
      element.setAttribute('content', content)
    }
  }
}

export default useDynamicSEO